import * as React from "react";
import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { IS_FEATURE_adunityPartner } from "../../../components/common/constants/constants"

import { styled } from "../../../stitches.config";
import { useStores } from "../../../helpers";
import Adslot from "../../../components/Adslot";
import { zIndexNavbar } from "./NavbarFixed";


const TopBarAdslot: React.FC = () => {
    const { pathname } = useLocation();
    const { UIStore } = useStores();
    const isMaterialPartnera = UIStore.isMaterialPartnera;
    const suffix = ((IS_FEATURE_adunityPartner && isMaterialPartnera) ? '_partner' : '');

    const getPagePrefix = (pathname: string) => {
        if (pathname === "/") {
            return "sg";
        } else if (pathname.lastIndexOf("/c/", 0) === 0) {
            return "kat";
        } else if (/^(\/(blogi\/\w+|zdrowie))?\/\d{1,},/.test(pathname)) {
            return "art";
        } else {
            return null;
        }
    };

    const prefix = getPagePrefix(pathname);

    const [showAdOnAbsolute, setShowAdOnAbsolute] = useState(true);

    type SlotRenderEndedEvent = {
        slot: {
            getAdUnitPath: () => string;
        };
    };


    const slotRenderHandlerRef = useRef<((event: SlotRenderEndedEvent) => void) | null>(null);

    useEffect(() => {
        const { googletag } = window;

        const handleSlotRenderEnded = (event: any) => {
            const adUnitPath = event?.slot?.getAdUnitPath?.();
            const isEmpty = event?.isEmpty;

            if (adUnitPath?.includes(`${prefix}_belka_top${suffix}`) && !isEmpty) {
                setShowAdOnAbsolute(true);
                setTimeout(() => setShowAdOnAbsolute(false), 1000);
            }
        };

        slotRenderHandlerRef.current = handleSlotRenderEnded;

        googletag?.cmd?.push(() => {
            googletag.pubads().addEventListener('slotRenderEnded', slotRenderHandlerRef.current);
        });

        return () => {
            googletag?.cmd?.push(() => {
                googletag.pubads().removeEventListener('slotRenderEnded', slotRenderHandlerRef.current);
            });
        };
    }, [prefix, suffix]);

    return (
        <>
            <Wrapper showAdOnAbsolute={showAdOnAbsolute} css={{ zIndex: zIndexNavbar + 1 }}>
                {!!prefix && <Adslot name={prefix + '_belka_top' + suffix} />}
            </Wrapper>
        </>
    );
};

const Wrapper = styled("div", {
    top: 0,
    left: 0,
    right: 0,
    //zIndex: 999999,
    variants: {
        showAdOnAbsolute: {
            true: {
                position: "fixed",
            },
            false: {
                position: "absolute",
            }
        }
    }
});


export default TopBarAdslot;
